import { Box, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";
import BackBtn from "../../components/BackBtn";

// ----------------------------------------------------------------------

export const VerifyTitle = () => {
	const { actions, state } = useContext(Context);
	const { translate } = useLocales();
	return (
		<>
			<Stack flexDirection={"row"} alignItems={"center"} gap={2}>
				<BackBtn onClick={() => actions.setStep(0)} />
				<Typography variant='h4'>{translate("demo.verify_title")}</Typography>
			</Stack>
			{state.email === "" ? (
				<Typography
					variant='body2'
					color='text.secondary'
					sx={{ mt: { xs: 3, sm: 2 }, maxWidth: 550 }}
				>
					{translate("demo.verify_des")}
				</Typography>
			) : (
				<Typography
					variant='body2'
					color='text.secondary'
					sx={{ mt: { xs: 3, sm: 2 }, maxWidth: 550 }}
				>
					{translate("demo.verify_code")}
					<Box display={"inline"} color='text.primary'>
						{state.email}
					</Box>
				</Typography>
			)}
		</>
	);
};

export default VerifyTitle;
